import { BaseLog } from './BaseLog';
import { LEVEL } from './LEVEL';
import { REFRAME_EVENTS_STACK } from '../../devtools/StackMiddleware';

export function OnboardingLog(message: string, stacktrace: string, data = {}, level = LEVEL.INFO) {
    return BaseLog({
        category: 'ONBOARDING',
        message,
        stacktrace,
        data: {
            data,
            reframe_stack: REFRAME_EVENTS_STACK
        },
        level
    });
}
